import { useParams } from 'react-router-dom';

import { GetOneSite } from '@/api/fe-api/view/queries/get-one-site';
import { Loading } from '@/components/ui/old/Loading';

import { Communication } from '../components/communication';

export function AssetCommunicationPage() {
  const { siteId } = useParams<{ siteId: string }>();
  const site = GetOneSite.useQuery({ id: siteId });

  if (site.isLoading) {
    return <Loading />;
  }

  if (site.isError) {
    throw site.error;
  }

  if (!site.data) {
    throw new Error('No data');
  }

  if (site.data.isErr()) {
    throw site.data.error;
  }

  return <Communication site={site.data.value} />;
}
